// Added by Bhaskar c 
import axios from 'axios';
import { DateTime } from 'luxon';
const AWF_CUST_ID = localStorage.getItem("awfCustId");

// Insert a space before each uppercase letter, then trim any leading spaces
export function splitCamelCase(input) {
  return input.replace(/([A-Z])/g, ' $1').trim();
}
  

export function computeOrderFields(order) {
  const uid = order?.order_customer_UID || order?.account_UID;
  const origPO = order?.order_customer_PO_number ?? "";
  const origUnique = order?.order_unique_id;

  if (uid === AWF_CUST_ID) {
    const newOrderUniqueId = origPO.substring(0, 6);            // first 6 chars (safe if shorter)
    const rest = origPO.length > 6 ? origPO.substring(6) : "";  // remainder after 6 chars
    const newOrderCustomerPO = String(origUnique) + rest;       // use original unique id, then rest
    return {
      order_unique_id: newOrderUniqueId,
      order_customer_PO_number: newOrderCustomerPO
    };
  } else {
    return {
      order_unique_id: order?.order_unique_id,
      order_customer_PO_number: order?.order_customer_PO_number
    };
  }
}

export const getNextBusinessDay = async () => {
    const todayISO = DateTime.now().toISODate();
    try {
      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
      
      const response = await axios.get(`${API_BASE_URL}next-delivery-date`, {
        params: { dateStr: todayISO },
        headers: {
          "x-access-token": localStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (response?.data?.date) {
        return response.data.date;
      }
    } catch (error) {
      console.error("Could not fetch next non-holiday delivery date:", error);
      return todayISO
    }
};

export const formatAustralianPhone = (input) => {
    let raw = input.replace(/\D/g, "");

    // Allow only up to 10 digits
    if (raw.length > 10) raw = raw.slice(0, 10);

    // Allow single 0
    if (raw === "0") return raw;

    // 03 Landline → 03 0000 0000
    if (raw.startsWith("03")) {
      if (raw.length <= 2) return raw;
      if (raw.length <= 6)
        return `${raw.slice(0, 2)} ${raw.slice(2)}`;
      return `${raw.slice(0, 2)} ${raw.slice(2, 6)} ${raw.slice(6)}`;
    }

    // 04 Mobile → 04xx xxx xxx
    if (raw.startsWith("04")) {
      if (raw.length <= 4) return raw;
      if (raw.length <= 7)
        return `${raw.slice(0, 4)} ${raw.slice(4)}`;
      return `${raw.slice(0, 4)} ${raw.slice(4, 7)} ${raw.slice(7)}`;
    }

    // Anything else → allow only single 0
    return raw === "0" ? raw : "";
  };

  export const isValidContact = (value) => {
    if (!value) return false;

    // Allow single 0
    if (value === "0") return true;

    // 03 format: 03 0000 0000
    const landlineRegex = /^03\s\d{4}\s\d{4}$/;

    // 04 format: 04xx xxx xxx
    const mobileRegex = /^04\d{2}\s\d{3}\s\d{3}$/;

    return landlineRegex.test(value) || mobileRegex.test(value);
  };